import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class App {
	isDev(): boolean {
		return (
			environment.environment === "development" ||
			environment.environment === "local"
		);
	}

	isProd(): boolean {
		return !this.isDev();
	}
}
